const MatchMedia = function (media_query) {
	var matchMedia = window.matchMedia;
	var is_supported = (typeof matchMedia === 'function');

	if (is_supported && media_query) {
		return matchMedia(media_query).matches;
	} else {
		return false;
	}
};

export default MatchMedia;
